/*global VeloxFormController, VeloxWebView*/
var upload = require("../../util/upload") ;

var domainSettingsController = new VeloxFormController("domain", {
    directory: "views/domain",
    name: "domainSettingsForm",
    route: "domain-settings"
});


domainSettingsController.getLogo = function(domain, callback){
    if(domain && domain.binary){
        this.api.readBinary.url(domain.binary, function(err, url){
            if(err){ return callback(err) ;}
            callback(null, url) ;
        }) ;
    }else{
        callback(null, "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8zwQAAgYBAyKDV6YAAAAASUVORK5CYII=") ;
    }
} ;

domainSettingsController.searchRecord = function(data, callback){
    this.api.api.multiread({
        domain: { 
            searchFirst: {} ,
            joinFetch: [
                {otherTable: "velox_binary", type: "2one", thisField: "do_code", otherField:"table_uid", name: "binary"}
            ]
        }
    }, function(err, reads){
        if(err){ return callback(err) ; }
        this.getLogo(reads.domain, function(err, logoUrl){
            if(err){ return callback(err) ;}
            reads.domain.logoUrl = logoUrl ;
            
            callback(null,reads.domain);
        }.bind(this)) ;
    }.bind(this)) ;
} ;


/**
 * User want to upload a logo
 */
domainSettingsController.onUploadLogo = function(){
    upload({
        multiple: false, 
        accept: "image/gif,image/jpeg,image/png",
        sizeLimit: 2000000
    },function(file){
        if(!file){ return ;}
        this.view.updateData() ;
        this.view.longTask(function(done){
            this.api.api.domain.searchFirst({}, function(err, domain){
                if(err){ return done(err) ;}

                if(err){ return done(err) ;}

                var binaryRecord = {
                    table_name: "domain", 
                    table_uid: domain.do_code, 
                    mime_type: file.type,
                    description : file.name,
                    filename: "logo"
                };
                if(this.data.binary){
                    binaryRecord.uid = this.data.binary.uid ;
                }
                this.api.saveBinary(
                file,
                binaryRecord, function(err, binary){
                    if(err){ return done(err) ;}
                    this.getLogo(this.data, function(err, logoUrl){
                        if(err){ return done(err) ;}
                        if(logoUrl.indexOf("http")===0){
                            logoUrl += "?"+new Date().getTime() ;
                        }
                        this.data.logoUrl = logoUrl;
                        this.data.binary = binary ;
                        this.view.render() ;
                    }.bind(this)) ;
                    done() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this));
} ;


module.exports = domainSettingsController ;